import { useState, useEffect } from 'react';
import { dashboardService, DashboardStats } from '../../services/platform-admin/dashboard.service';
import { usePlatformAdminAuthStore } from '../../stores/platform-admin-auth.store';

export function useDashboard() {
  const [stats, setStats] = useState<DashboardStats | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const token = usePlatformAdminAuthStore((state) => state.token);

  const loadStats = async () => {
    if (!token) return;

    try {
      setLoading(true);
      setError(null);
      const data = await dashboardService.getStats(token);
      setStats(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load stats');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadStats();
  }, [token]);

  return {
    stats,
    loading,
    error,
    refetch: loadStats,
  };
}
